import Component from '../core/Component'
import PhotoSwipe from 'photoswipe'
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'
import { queryAll, toggleClass } from '../utils/dom'

const template = `
<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="pswp__bg"></div>
    <div class="pswp__scroll-wrap">
        <div class="pswp__container">
            <div class="pswp__item"></div>
            <div class="pswp__item"></div>
            <div class="pswp__item"></div>
        </div>
        <div class="pswp__ui pswp__ui--hidden">
            <div class="pswp__top-bar">
                <div class="pswp__counter"></div>
                <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>
                <button class="pswp__button pswp__button--share" title="Share"></button>
                <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>
                <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>
                <div class="pswp__preloader">
                    <div class="pswp__preloader__icn">
                      <div class="pswp__preloader__cut">
                        <div class="pswp__preloader__donut"></div>
                      </div>
                    </div>
                </div>
            </div>
            <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
                <div class="pswp__share-tooltip"></div>
            </div>
            <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">
            </button>
            <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
            </button>
            <div class="pswp__caption">
                <div class="pswp__caption__center"></div>
            </div>
        </div>
    </div>
</div>
`

const buffer  = document.createElement('div')
buffer.innerHTML = template
document.body.appendChild(buffer)

const galleryRoot = buffer.querySelector('.pswp')

export default class Lightbox extends Component {

    constructor(element) {
        super(element)

        this.photowsipeOptions = {
            shareEl: false,
            showHideOpacity: true,
            bgOpacity: 1,
            history: false,
            fullscreenEl: true,
            counterEl: false,
            zoomEl:true
        }

        this.thumbnails = null
    }

    prepare() {
        this.items = JSON.parse(this.element.textContent)
        this.createThumbnails()
    }

    createThumbnails() {
        const thumbnailsRoot = galleryRoot.querySelector('.pswp__thumbnails')

        if (!thumbnailsRoot) {
            this.thumbnails = []
            return
        }

        thumbnailsRoot.innerHTML = this.items
            .map(item => ({
                id: item.id,
                ...item.thumb
            }))
            .map(item => `
                <div class="pswp__thumbnail" data-id="${item.id}">
                    <img
                        src="${item.src}"
                        srcset="${item.srcRetina} 2x"
                        width="${item.width || ''}"
                        height="${item.height || ''}"
                        alt="">
                </div>`
            )
            .join('')

        thumbnailsRoot.addEventListener('click', this.handleThumbnailClick)

        this.thumbnails = queryAll('.pswp__thumbnail', thumbnailsRoot)
    }

    show(id) {
        if (!this.thumbnails) {
            this.createThumbnails()
        }
        const index = this.items.findIndex(item => `${item.id}` === `${id}`)

        if (index === -1) {
            return
        }

        if (!this.gallery) {
            this.photowsipeOptions.index = index

            const items = this.items.map(item => ({
                src: item.src,
                w: item.width,
                h: item.height
            }))

            this.gallery = new PhotoSwipe(galleryRoot, PhotoSwipeUI_Default, items, this.photowsipeOptions)
            this.gallery.listen('afterChange', this.handleAfterChange)
            this.gallery.listen('destroy', this.handleDestroy)
            this.gallery.init()
        } else {
            this.gallery.goTo(index)
        }


    }

    handleThumbnailClick = event => {
        const target = event.target.closest('[data-id]')

        if (!target) {
            return
        }

        this.show(target.dataset.id)
    }

    handleDestroy = event => {
        this.gallery = null
    }

    handleAfterChange = () => {
        const current = this.gallery.getCurrentIndex()
        if (this.thumbnails) {
            this.thumbnails.forEach((element, index) => toggleClass(element, 'is-active', index === current))
        }
    }
}
